import { AssetsSvgMap } from '@libs/types';
import { CommonScreen } from '../../../common/CommonScreen/CommonScreen';
import React from 'react';
import { ModalWithTimer } from '../../UI/ModalWithTimer/ModalWithTimer';

const CodeTimerScreen = ({ text }: { text?: string }) => {
    return (
        <ModalWithTimer>
            <CommonScreen useIcon={false} iconName={AssetsSvgMap.ic_check_circle_thin} fill="purple_100" mainText={text} />
        </ModalWithTimer>
    );
};
export { CodeTimerScreen };
